import admin from '../../vi/page/admin';
import auth from './auth';
import other from './other';

export default {
  ...admin,
  ...auth,
  ...other,
};
